import { FC } from 'react';
import { ReactComponent as LineIcon } from 'resources/images/line.svg';
import { Audio } from 'types/audio';
import { Checkbox, CheckboxProps, Icon, Spinner } from '@chakra-ui/react';

interface PrivateCheckboxProps {
  isUpdating: boolean;
  audio: Audio;
  handleCheckboxAudio: () => void;
}

export const PrivateCheckbox: FC<PrivateCheckboxProps> = ({
  isUpdating,
  audio,
  handleCheckboxAudio,
}) => (
  <>
    {isUpdating ? (
      <Spinner data-testid="audio-private-loading" size="md" m={2} />
    ) : audio.isMine ? (
      <Checkbox
        isChecked={audio.isPrivate}
        onChange={handleCheckboxAudio}
        inputProps={
          {
            'data-testid': 'audio-private-checkbox',
          } as CheckboxProps['inputProps']
        }
      />
    ) : (
      <Icon as={LineIcon} width="initial" height="initial" color="baseText" />
    )}
  </>
);
